import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetNewsletterProps {
  community_id: string;
  newsletter_no: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getNewsletter = async (community_id: string, newsletter_no: string) =>
  await axiosAuth.get(
    `${GET_COMMUNITIES}/${community_id}/newsletter/${newsletter_no}/presigned-url`
  );

const useGetNewsletter = ({
  community_id,
  newsletter_no,
  queryParams,
}: UseGetNewsletterProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["news-letter", community_id, newsletter_no],
    queryFn: () => getNewsletter(community_id, newsletter_no),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetNewsletter;
